import DischargedPatients from './DischargedPatients';

export default DischargedPatients;
